
const consoleWelcome = String.raw`

                            _//       _//      _/       _/////    _////////
                            _/ _//   _///     _/ //     _//   _// _//      
                            _// _// _ _//    _/  _//    _//    _//_//      
                            _//  _//  _//   _//   _//   _//    _//_//////  
                            _//   _/  _//  _////// _//  _//    _//_//      
                            _//       _// _//       _// _//   _// _//      
                            _//       _//_//         _//_/////    _////////

                                            .-.-. .-.-. 
                                            '. B )'. Y )
                                             ).'   ).' 
      ___                         ___           ___                        ___                    ___     
     /  /\          ___          /  /\         /  /\           ___        /  /\                  /  /\    
    /  /::\        /__/\        /  /:/        /  /::\         /__/\      /  /::\                /  /::\   
   /__/:/\:\       \  \:\      /  /:/        /  /:/\:\        \__\:\    /  /:/\:\              /__/:/\:\  
  _\_ \:\ \:\       \__\:\    /  /:/        /  /:/  \:\       /  /::\  /  /:/  \:\            _\_ \:\ \:\ 
 /__/\ \:\ \:\      /  /::\  /__/:/     /\ /__/:/ \__\:|   __/  /:/\/ /__/:/ \__\:\          /__/\ \:\ \:\
 \  \:\ \:\_\/     /  /:/\:\ \  \:\    /:/ \  \:\ /  /:/  /__/\/:/~~  \  \:\ /  /:/          \  \:\ \:\_\/
  \  \:\_\:\      /  /:/__\/  \  \:\  /:/   \  \:\  /:/   \  \::/      \  \:\  /:/            \  \:\_\:\  
   \  \:\/:/     /__/:/        \  \:\/:/     \  \:\/:/     \  \:\       \  \:\/:/              \  \:\/:/  
    \  \::/      \__\/          \  \::/       \__\::/       \__\/        \  \::/                \  \::/   
     \__\/                       \__\/            ~~                      \__\/                  \__\/    

`

export default {
  console: consoleWelcome
}
